import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import {
  EditOutlined,
  SettingOutlined,
  ShopOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  UserOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut, getProfile } from 'redux/actions/Auth';
import AppService from "services/AppService";
import { API_BASE_URL } from "configs/AppConfig";
import { Link, useHistory } from "react-router-dom";


export const NavProfile = ({ signOut, getProfile, profile,redirect }) => {
  const profileImg = (profile?.profileImg)?`${API_BASE_URL}/image/profile/${profile?.profileImg}`:`/img/user.svg`
  const history = useHistory()
  const menuItem = [
    {
      title: "Dashboard",
      icon: UserOutlined,
      path: `/app/dashboard`
    },
    {
      title: "Applied Jobs",
      icon: UnorderedListOutlined,
      path: `/app/home/applied-jobs`
    },
    {
      title: "Edit Profile",
      icon: EditOutlined,
      path: `/app/profile/edit`
    }
  ]
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex align-items-center">
          <Avatar size={40} src={profileImg} />
          <div className="pl-3">
            <h4 className="mb-0 text-capitalize" >{profile?.firstName}</h4>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={e => {
            signOut()
            history.push(redirect)
          }}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  useEffect(() => {
    getProfile()
    //  AppService.fetchProfile().then(resp=>{
    //    console.log(resp)
    //    setProfile(resp)
    //  }).catch(e=>console.log(e))

  }, [])
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item className="p-0">
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}
const mapStateToProps = ({ auth }) => {
  const { profile,redirect } = auth;
  return { profile,redirect }
}

export default connect(mapStateToProps, { signOut, getProfile })(NavProfile)
